
import axios, { AxiosRequestConfig } from 'axios';
import { DevicesResponse, RfCodeCreateRequest, RfCodesResponse ,DevicesDto} from '@gtpl/shared-models/canteen-management';
import { connection } from '../../freebies-management';

export class DevicesServices {
    URL = connection.DEPLOY_URL + '/devices';

    async createRfCode(rfCodeReq: RfCodeCreateRequest): Promise<RfCodesResponse> {
        return await axios.post(this.URL + '/createRfCode',rfCodeReq)
            .then(res => {
                return res.data
            })
    }

    async deleteRfCode(rfCodeReq: RfCodeCreateRequest): Promise<RfCodesResponse> {
        return await axios.post(this.URL + '/deleteRfCode',rfCodeReq)
            .then(res => {
                return res.data
            })
    }

    async getRfCodeRecordByRfCode(rfCodeReq: RfCodeCreateRequest): Promise<RfCodesResponse> {
        return await axios.post(this.URL + '/getRfCodeRecordByRfCode',rfCodeReq)
            .then(res => {
                return res.data
            })
    }

    async getAllRfCode(): Promise<RfCodesResponse> {
        return await axios.post(this.URL + '/getAllRfCode')
            .then(res => {
                return res.data
            })
    }

    async createDevices(request: DevicesDto): Promise<RfCodesResponse> {
        return await axios.post(this.URL + '/createDevices',request)
            .then(res => {
                return res.data
            })
    }

    async getAllDevices(): Promise<RfCodesResponse> {
        return await axios.post(this.URL + '/getAllDevices')
            .then(res => {
                return res.data
            })
    }

    async deleteDevices(request: DevicesDto): Promise<RfCodesResponse> {
        return await axios.post(this.URL + '/deleteDevices',request)
            .then(res => {
                return res.data
            })
    }

}